<div class="vehicle-wrapper">
  <div class="top-header">
    <h3>{{ register?.name || 'Register Entry' }}</h3>
    <p *ngIf="register?.description">{{ register.description }}</p>
  </div>

  <div class="step-label">
    <strong>Step {{ currentStep }}: {{ stepLabel }}</strong>
  </div>

  <div *ngIf="isLocked" class="error-msg">
    This entry is locked for edits.
  </div>

  <form [formGroup]="entryForm">
    <div formArrayName="values" class="form-row">
      <ng-container *ngFor="let field of fields; let i = index">
        <div *ngIf="field.step_number === currentStep" [formGroupName]="i" class="form-item">
          <label>
            {{ field.name }}
            <small *ngIf="field.is_mandatory">*</small>
          </label>

          <ng-container [ngSwitch]="field.data_type">
            <input *ngSwitchCase="'text'" type="text" formControlName="value" />
            <textarea *ngSwitchCase="'textarea'" rows="3" formControlName="value"></textarea>
            <input *ngSwitchCase="'number'" type="number" formControlName="value" />
            <p-datepicker
              *ngSwitchCase="'date'"
              formControlName="value"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showOnFocus]="true"
              [showButtonBar]="true"
              [readonlyInput]="true">
            </p-datepicker>
            <p-datepicker
              *ngSwitchCase="'datetime'"
              formControlName="value"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showOnFocus]="true"
              [showButtonBar]="true"
              [readonlyInput]="true"
              [showTime]="true"
              hourFormat="24">
            </p-datepicker>

            <select *ngSwitchCase="'dropdown'" formControlName="value">
              <option [ngValue]="null">Select</option>
              <option *ngFor="let option of getClusterValues(field.cluster)" [value]="option.value">
                {{ option.value }}
              </option>
            </select>

            <div *ngSwitchCase="'radio'">
              <div class="check" *ngFor="let option of getClusterValues(field.cluster)">
                <input type="radio" [value]="option.value" formControlName="value" />
                {{ option.value }}
              </div>
            </div>

            <div *ngSwitchCase="'checkbox'">
              <div class="check" *ngFor="let option of getClusterValues(field.cluster)">
                <input
                  type="checkbox"
                  [checked]="isOptionChecked(i, option.value)"
                  (change)="toggleCheckboxValue(i, option.value)"
                />
                {{ option.value }}
              </div>
            </div>

            <div *ngSwitchCase="'file'">
              <input type="file" (change)="onFileSelected($event, i)" />
              <div *ngIf="valuesArray.at(i).get('file_url')?.value">Uploaded</div>
            </div>

            <div *ngSwitchCase="'image'">
              <input type="file" accept="image/*" (change)="onFileSelected($event, i)" />
              <div *ngIf="valuesArray.at(i).get('file_url')?.value">Uploaded</div>
            </div>
          </ng-container>

          <div class="error" *ngIf="valuesArray.at(i).invalid && valuesArray.at(i).touched">
            <small>Invalid value</small>
          </div>
        </div>
      </ng-container>
    </div>
  </form>

  <div class="button-row">
    <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
    <button type="button" class="btn-cancel" (click)="goPrevious()">Previous</button>
    <button type="button" class="btn-save" (click)="goNext()">Next</button>
    <button type="button" class="btn-save" (click)="submitFinal()">
      Submit
    </button>
  </div>
</div>
